<script setup lang="ts">
import type { Priceable } from '#shared/types/pricing'

const props = defineProps<{ priceable?: Priceable, singularPrice?: boolean }>()

const auth = useAuthorizeStore()

const prices = usePrices(() => props.priceable, 'recurring')

const data = computed(() => {
  if (prices.value === 'NOT_APPLICABLE') {
    return undefined
  }

  const exVatPrice = prices.value?.actual?.exVat

  let basePrice: number | undefined
  if (props.priceable) {
    const { withoutVat } = taxConverter(props.priceable)
    basePrice = withoutVat(props.priceable.prices.default)
  }

  return {
    isMetered: (prices.value?.actual?.isMetered && (exVatPrice !== basePrice || !auth.loggedIn)) ?? false,
    exVatPrice,
    savings: basePrice && exVatPrice ? basePrice - exVatPrice : 0,
  }
})
</script>

<template>
  <p v-if="data?.isMetered && data?.savings">
    Skolen har avtalepris hos Aschehoug på {{ norwegianPrice(data.exVatPrice) }} pr. elev, dere får {{ norwegianPrice(data.savings) }} i kvantumsrabatt.
  </p>
  <p v-else-if="!data?.isMetered">
    Prisen{{ singularPrice ? '' : 'e' }} gjelder for {{ isConsumer(auth.user) ? "privatpersoner" : "bedrifter" }}. <LoginLink class="underline" :provider="isConsumer(auth.user) ? 'feide' : 'vipps'" /> for å bestille som
    {{ isConsumer(auth.user) ? "bedrift" : "privatperson" }}.
  </p>
</template>
